<template>
    <form style="cursor: pointer">
        <div ref="dropZone" class="drop-zone" @dragover.prevent @drop.prevent="handleDrop" @click="openPicker">
            <p class="pa-0 ma-0">画像フォルダをドラッグ＆ドロップ</p>

            <!-- 隠しinput -->
            <input ref="fileInput" type="file" webkitdirectory multiple hidden @change="handleFiles" />
        </div>
    </form>
</template>
  
<script>
export default {
    name: "UploadAreaInput",
    props: {
        value: { type: Object, default: () => ({ files: [], folder: null }) },
    },
    data() {
        return {
            files: [],
            folderName: null,
        };
    },
    mounted() {
        const dropZone = this.$refs.dropZone;
        dropZone.addEventListener("dragover", (e) => e.preventDefault());
        dropZone.addEventListener("drop", this.handleDrop);
    },
    methods: {
        openPicker() {
            this.$refs.fileInput.click();
        },
        handleFiles(event) {
            const files = Array.from(event.target.files);
            // input で選択された場合は webkitRelativePath が使える
            const folderName = files.length > 0
                ? files[0].webkitRelativePath.split("/")[0]
                : null;
            this.setFiles(files, folderName);
        },
        async handleDrop(e) {
            e.preventDefault();
            const files = e.dataTransfer.files;
            const items = e.dataTransfer.items;
            let allFiles = [];
            let rootFolder = null;

            if (!items[0].webkitGetAsEntry().isFile) {
                for (let i = 0; i < items.length; i++) {
                    const entry = items[i].webkitGetAsEntry();
                    if (entry) {
                        if (!rootFolder) {
                            // D&D の場合はルートの entry 名をフォルダ名にする
                            rootFolder = entry.isDirectory ? entry.name : null;
                        }
                        const files = await this.traverseFileTree(entry);
                        allFiles = allFiles.concat(files);
                    }
                }
            }
            else {
                //ファイルアップロード時の処理
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    allFiles.push(file);
                }
            }

            this.setFiles(allFiles, rootFolder);
        },
        async traverseFileTree(entry, path = '') {
            let files = [];

            if (entry.isFile) {
                const file = await new Promise((resolve) => entry.file(resolve));
                // フォルダパスを保持するためカスタムプロパティを追加
                file.relativePath = path + file.name;
                files.push(file);
            } else if (entry.isDirectory) {
                const reader = entry.createReader();

                const readAllEntries = async () => {
                    const chunk = await new Promise((resolve, reject) => {
                        reader.readEntries(resolve, reject);
                    });

                    if (chunk.length === 0) return;

                    for (const ent of chunk) {
                        const nestedFiles = await this.traverseFileTree(ent, path + entry.name + '/');
                        files = files.concat(nestedFiles);
                    }

                    await readAllEntries(); // 次の塊を読む
                };

                await readAllEntries();
            }

            return files;
        },
        setFiles(files, folderName) {
            this.files = files;
            this.folderName = folderName;

            // 親に渡す { files, folder }
            this.$emit("input", {
                files: this.files,
                folder: this.folderName,
            });
        },
    },
};
</script>
  
<style scoped>
.upload-wrapper {
    width: 100%;
}

.drop-zone {
    border: 2px solid #000;
    border-radius: 12px;
    padding: 40px;
    text-align: center;
    color: #000;
    cursor: pointer;
    transition: background 0.2s;
}

.drop-zone:hover {
    background: #999999;
}
</style>
